import React, { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "../styles/Lectures.css"; 
import mlogo from "../assets/ntmlogo.jpg";

const Lectures10 = () => {
  const { subject } = useParams();
  const navigate = useNavigate();

  // ✅ Redirect if user is not logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!isLoggedIn) {
      navigate("/login"); // Redirect to login
    }
  }, [navigate]);

  const lectures = {
    Science: [
      { name: "Science Lectures", index: 0 },
      { name: "Science PDF", index: 1},
    ],
    Maths: [
      { name: "Maths Lectures", index: 0 },
      { name: "Maths PDF", index: 1},
    ],
    SST: [
      { name: "SST Lectures", index: 0 },
      { name: "SST PDF", index: 1},
    ],
    English: [
      { name: "English Lectures", index: 0 },
      { name: "English PDF", index: 1},
    ],
    Hindi: [
      { name: "Hindi Lectures", index: 0 },
      { name: "Hindi PDF", index: 1},
    ],
    It: [
      { name: "IT Lectures", index: 0 },
      { name: "IT PDF", index: 1},
    ],
  };

  return (
    <div className="lectures-container">
      <img src={mlogo} alt="Logo" className="big-logo" />
      <h2>{subject} Lectures</h2>
      <div className="lecture-boxes">
        {lectures[subject]?.map((lecture, index) => (
          <Link
            key={index}
            to={`/chapter-lectures-abhay/${subject}/${lecture.index}`}
            className="lecture-box"
          >
            {lecture.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Lectures10;
